import { ApiError } from '@gorila-shared-ui/components';
import { PaginatedResponse } from '../types/app';
import { Company, CompanyRequest } from '../types/companies';
import { getRequest, postRequest } from './api';
import { URLS } from './urls/urls';

export const getCompanies = async (
  page: number = 1,
  search: string = '',
  projection: string = 'full'
): Promise<{
  paginatedResponse?: PaginatedResponse<Company>;
  error?: ApiError;
}> => {
  const response = await getRequest(URLS.companies.all, {
    queryParams: { page, search, projection },
  });
  return {
    paginatedResponse: response?.data,
    error: response?.error,
  };
};

export const createCompany = async (company: CompanyRequest): Promise<{ error?: ApiError }> => {
  const response = await postRequest(URLS.companies.create, { body: company });
  return {
    error: response?.error,
  };
};

export const updateCompany = async (companyId: string, company: CompanyRequest): Promise<{ error?: ApiError }> => {
  const response = await postRequest(URLS.companies.update(companyId), {
    body: company,
  });
  return {
    error: response?.error,
  };
};
